<template>
    <div>
        <v-container class="main-header white py-0 px-sm-2 px-0" :class="{'isCheckout': isCheckout}">
            <v-layout align-center class="text-center">
                <v-flex xs2 sm4>

                </v-flex>
                <v-flex xs6 sm4 style="line-height: 0;">
                    <router-link to="/" class="main-link">
                        <img :src="require('../../assets/Eurooil_logo.svg')" class="custom-logo" :class="{'isCheckout': isCheckout}" itemprop="logo" />
                    </router-link>
                </v-flex>
                <v-flex xs4 sm4 class="justify-end">
                    <div class="d-flex align-center justify-end">
                        <strong>{{ user.firstName }} {{ user.lastName }}</strong>
                    </div>
                    <div class="d-flex align-center justify-end">
                         <span @click="drawer = true" v-if="!isCheckout">
                        <v-badge
                                :content="itemsInCart"
                                :value="itemsInCart"
                                color="secondary"
                                overlap
                                class="main-cart align-center"
                        >
                            <span class="cart-title mr-2">nákupní košík</span>
                            <v-icon :class="{mobileCart: $vuetify.breakpoint.xsOnly}">mdi-cart-outline</v-icon>
                        </v-badge>
                    </span>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <v-navigation-drawer
                temporary
                v-model="drawer"
                :right="true"
                fixed
                width="340"
        >
            <cart-overlay @drawerClose="drawer = false" />
        </v-navigation-drawer>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CartOverlay from '../Cart/CartOverlay'

    export default {
        name: 'MainHeader',
        props: ['isCheckout'],
        data () {
            return {
                drawer: false
            }
        },
        components: {
            CartOverlay
        },
        computed: {
            ...mapGetters([
                'cartProducts',
                'user'
            ]),
            itemsInCart() {
                let cart = this.cartProducts;
                if (!cart[0]) return null;
                return cart.reduce((accum, item) => accum + item.qty, 0)
            }
        }
    }
</script>

<style lang="scss">
    .main-header {
        .main-link {
            line-height: 0;
        }
        .main-cart {
            display: inline-flex;
            cursor: pointer;
        }
        .cart-title {
            display: inline-flex;
            margin-top: 5px;
        }
        .cart-image {
            cursor: pointer;
            width: 40px;
        }
        .mobileCart {
            max-width: 80px;
        }
        &.isCheckout {
            padding-top: 0;
            padding-bottom: 0;
        }
        .menu-item {
            a {
                padding: 0 1em;
                font-size: 16px;
                color: #FFFFFF !important;
                text-decoration: none;
                text-transform: uppercase;
                &:hover {
                    opacity: 0.7;
                }
            }
        }
        .main-title {
            color: #FFFFFF;
            font-weight: 300;
            text-transform: uppercase;
            margin-left: 40px;
            strong {
                display: block;
                font-weight: 700;
                font-size: 32px;
                line-height: 32px;
            }
        }
        .mobile-custom-logo {
            max-width: 140px;
        }
        .custom-logo {
            width: 120px;
            &.isCheckout {
                width: 80px;
            }
        }
        .menu-icon-link {
            border-radius: 7px !important;
        }
        .v-list, .v-menu__content {
            border-radius: 0 !important;
        }
        .v-menu__content {
            max-width: 100% !important;
            width: 100%;
            left: 0 !important;
        }
        .v-chip {
            .v-chip__content {
                cursor: pointer !important;
            }
        }
        .opening-hours {
            strong {
                display: block;
                font-weight: 600;
                font-size: 14px;
            }
        }
    }
</style>
